module.exports = __webpack_public_path__ + "img/youjiantou.15e58f8c.png";